import merge from 'lodash/merge';
import clone from 'lodash/clone';
import isMobile from '../lib/isMobile';
import fluxDefaults from './defaultsLarge';
import squareWalls from './partials/squareWalls';

const mobile = isMobile();

module.exports = merge(
    clone(fluxDefaults, true),
    squareWalls,
    {
        gravity: -1,
        initialTicks: 10,
        walls: [
            // left
            {
                x: '-5%',
                y: '-5%',
                width: '5%',
                height: '105%',
            },
            // right
            {
                x: '100%',
                y: '-5%',
                width: '5%',
                height: '105%',
            },
        ],
        movingWalls: [
            {
                width: 20,
                height: 20,
                x: '30%',
                y: '-10%',
                tween: {
                    y: '40%',
                    duration: 1,
                    repeat: -1,
                    delay: 0.22,
                    ease: Linear.easeNone,
                },
            },
            {
                width: 20,
                height: 20,
                x: '63%',
                y: '-10%',
                tween: {
                    y: '40%',
                    duration: 1,
                    repeat: -1,
                    delay: 0.33,
                    ease: Linear.easeNone,
                },
            },
            {
                width: 20,
                height: 20,
                x: '3%',
                y: '-10%',
                tween: {
                    y: '35%',
                    duration: 1,
                    repeat: -1,
                    delay: 0.45,
                    ease: Linear.easeNone,
                },
            },
            {
                width: 20,
                height: 20,
                x: '93%',
                y: '-10%',
                tween: {
                    y: '35%',
                    duration: 1,
                    repeat: -1,
                    delay: 0.56,
                    ease: Linear.easeNone,
                },
            },
        ],
        blobs: [
            // main blobs
            {
                x: '0%',
                y: '70%',
                width: '100%',
                height: mobile ? '12%' : '12%',
                color: [0, 0, 0, 255],
            },
            {
                x: '0%',
                y: '80%',
                width: '100%',
                height: mobile ? '3%' : '3%',
                color: [255, 0, 0, 255],
            },
            {
                x: '0%',
                y: '85%',
                width: '100%',
                height: mobile ? '3%' : '3%',
                color: [0, 255, 0, 255],
            },
            {
                x: '0%',
                y: '90%',
                width: '100%',
                height: mobile ? '3%' : '3%',
                color: [0, 0, 255, 255],
            },
            {
                x: '0%',
                y: '72%',
                width: '100%',
                height: mobile ? '3%' : '3%',
                color: [0, 0, 255, 255],
            },
        ],
    }
);



// WEBPACK FOOTER //
// ./js/flux/lowGravity.js